import { CheckboxItem } from '@pc/common';
import { Dependency, EPproductSelectionType, ExcessLevel, InsuredAmount } from './quote/basic-quote.interface';
import { ICoverTraveler } from './cover-traveler.interface';
import { ICategoryValue } from './benefit.interface';

export interface ICover {
  id: number;
  name: string;
  icon: string;
  description: string;
  isDefault: boolean;
  isEditable: boolean;
  isPolicyCover: boolean;
  isMustAll: boolean;
  onlyOneMember: boolean;
  isPolicyCoverApplied?: boolean;
  dependentsIncluded: boolean;
  travelers: ICoverTraveler[] | null;
  benefitCategoryId: number;
  isOptional?: boolean;
  isCFAR?: boolean;
  isMandatory?: boolean;
  isUnavailable?: boolean;
  category?: ICategoryValue;
  allPeriod: boolean;
  coverType: CoverType;
  items: boolean;
  levels: CoverLevel[];
  webSiteOrder: number;
  pricePlanCurrency: number;
  maxDays: number;
  minDays: number;
  nameLocal: string;
  priceBillingCurrency: number;
  showInWebsite: boolean;
  isIncluded: boolean;
  dependencies?: Dependency[];
}

export enum CoverType {
  hidden = 0,
  core = 1,
  optional = 2,
  activity = 3
}

export interface CoversTranslations {
  title: string;
  subtitle: string;
  disclaimer?: string;
  excess: string;
  buttonAriaLabel: string;
  buttonTitle: string;
}
export interface ICoverDisplay {
  id: number;
  name: string;
  icon: string;
  description: string;
  benefitCategoryId?: number;
  productType?: EPproductSelectionType;
  InsuredAmount?: InsuredAmount[];
  excessLevels?: ExcessLevel[];
  label?: string;
  placeholder?: string;
  selectOptions?: CheckboxItem[];
  isIncluded?: boolean;
  dependencies?: Dependency[];
}

export interface IProductDisplay {
  policyGroupID: number;
  name: string;
  icon: string;
  description: string;
  type: EPproductSelectionType;
  InsuredAmount: InsuredAmount[];
  covers: ICoverDisplay[];
}

export interface PickedCover {
  id: number;
  name: string;
  price: number;
  type: CoverType;
  websiteOrder: number;
  quantity: number;
  showInWebsite?: boolean;
}

export interface CoverLevel {
  benefitId: number;
  displayName: string;
  id: number;
  levelName: string;
  optionalRiderId: number;
}
